// Client RPC typé de Hono, pour le front.
import { hc } from 'hono/client'
import type { AppApi } from './app'

export type { AppApi }

export function creerClientApi(base: string, options?: Parameters<typeof hc>[1]) {
  return hc<AppApi>(base, options)
}
